import FundingScreenRouter from 'features/onboarding/screens/FundingScreenRouter/FundingScreenRouter';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function OnboardingFundingPage() {
  return (
    <PinwheelContextProvider>
      <FundingScreenRouter />
    </PinwheelContextProvider>
  );
}
